import React, { useMemo } from 'react';

import qs from 'qs';
import { useHistory, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import { generateTableHead } from '../../../helpers';

const Head = ({ sort }) => {
  const history = useHistory();
  const location = useLocation();
  const queryString = qs.parse(location.search.slice(1));

  const headers = useMemo(() => generateTableHead('main', sort), [sort]);

  const sendSortValue = (e, item) => {
    e.preventDefault();

    if (item.active === 'desc') {
      delete queryString.page;
      queryString.sort = item.asc;
    }

    if (item.active === 'asc' || !item.active) {
      delete queryString.page;
      queryString.sort = item.desc;
    }

    return history.push(`${location.pathname}?${(location.search = qs.stringify(queryString))}`);
  };

  return (
    <thead>
      <tr>
        {headers?.map((head) => (
          <th key={head.title} className={head.class} {...head.attrs}>
            {head.sort
              ? (
                <a href="# " onClick={(e) => sendSortValue(e, head)}>
                  {head.title}
                  {' '}
                  {head?.active === 'desc' ? <FontAwesomeIcon icon={faSortDown} /> : ''}
                  {head?.active === 'asc' ? <FontAwesomeIcon icon={faSortUp} /> : ''}
                  {head?.active !== 'asc' && head?.active !== 'desc' ? <FontAwesomeIcon icon={faSort} /> : ''}
                </a>
              ) : head.title}
          </th>
        ))}
      </tr>
    </thead>
  );
};

Head.propTypes = {
  sort: PropTypes.object,
};

export default Head;
